import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { ButtonPrimary, SectionLabel } from './UI';
export const Hero = () => {
  const bullets = ['LLC paso a paso, sin confusión', 'EIN y cuenta bancaria business', 'Evita errores que cuestan cientos de dólares'];
  return <section className="relative overflow-hidden bg-pageBg" data-id="element-53">
      <div className="relative z-10 max-w-[760px] mx-auto px-6 py-16 md:py-24 text-center" data-id="element-54">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: [0.21, 0.47, 0.32, 0.98]
      }} data-id="element-55">
          {/* Badge */}
          <SectionLabel data-id="element-56">
            Para emprendedores latinos que quieren su empresa en EE.UU.
            funcionando ya.
          </SectionLabel>

          {/* Headline */}
          <h1 className="font-serif text-[clamp(2.2rem,5vw,3.6rem)] leading-[1.1] text-headline mb-5 font-bold" data-id="element-57">
            Ya investigaste suficiente.
            <br data-id="element-58" />
            <span className="text-accent" data-id="element-59">Es hora de ejecutar.</span>
          </h1>

          {/* Subheadline */}
          <p className="text-[1.15rem] text-body max-w-[540px] mx-auto mb-8 leading-relaxed" data-id="element-60">
            El mapa completo para crear tu empresa en USA. Sin perderte. Sin
            errores costosos.
          </p>

          {/* Bullet points */}
          <ul className="inline-flex flex-col gap-3 mt-2 mb-10 text-left" data-id="element-61">
            {bullets.map((b, i) => <li key={i} className="flex items-center gap-3 text-[1.05rem] text-body" data-id="element-62">
                <Check className="w-5 h-5 text-accent shrink-0" strokeWidth={3} data-id="element-63" />
                <span data-id="element-64">{b}</span>
              </li>)}
          </ul>

          {/* CTA */}
          <div className="flex flex-col items-center gap-3" data-id="element-65">
            <ButtonPrimary text="👉 Descargar Mi Guía $27.99" href="https://inkovacreation.store/shop/0de4a31b-dafb-4911-b0f5-64f146eb7e48" className="w-full sm:w-auto" data-id="element-66" />
            {/* Micro-trust text */}
            <p className="mt-2 text-[0.85rem] text-body" data-id="element-67">
              📄 PDF en español · Acceso inmediato · Pago seguro
            </p>
          </div>
        </motion.div>

        {/* Hero Image */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: [0.21, 0.47, 0.32, 0.98]
      }} className="mt-12 flex justify-center" data-id="element-68">
          <img src="https://cdn.magicpatterns.com/uploads/5U8DBke5TR65fjpaU46dLL/ChatGPT_Image_May_27,_2026,_12_03_53_PM.png" alt="Guía Digital Ruta USA 360 en iPhone" className="w-[85%] max-w-[420px]" data-id="element-69" />
        </motion.div>
      </div>
    </section>;
};